// extracted by mini-css-extract-plugin
export default {"header":"Header_header__CgFpU","main-image":"Header_main-image__AE85+"};